import {SearchX} from 'lucide-react';
import type {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';

import {Typography} from '@/components/ui/typography';
import {cn} from '@/utils/ui';

export type InfoStateProps = {
  title?: string;
  description?: string;
  icon?: ReactNode;
  className?: string;
};

const InfoState = ({title, description, icon, className}: InfoStateProps) => {
  const {t} = useTranslation();

  return (
    <div
      className={cn(
        'flex flex-col gap-3 justify-center items-center text-center h-full w-full px-4',
        className
      )}
    >
      {icon || <SearchX size={50} className="text-mint-500" />}

      <Typography variant="h3" className="text-2xl">
        {title || t('Not found')}
      </Typography>

      {description && (
        <Typography className="text-sm text-muted-foreground max-w-md">
          {description}
        </Typography>
      )}
    </div>
  );
};

export default InfoState;
